// extracted by mini-css-extract-plugin
export default {"container":"style_container__tPBF3","tabs":"style_tabs__MsOz+","tab":"style_tab__KQYdy"};